import React from 'react';
import '../styles.css';

function ConfirmationDialog({ message, onConfirm, onCancel, confirmText = "Yes", cancelText = "Cancel", confirmClassName = "", loading = false, confirmDisabled = false }) {
  return (
    <div className="confirmation-dialog-overlay">
      <div className="confirmation-dialog">
        <div>{message}</div>
        <div className="confirmation-dialog-actions">
          <button
            onClick={onConfirm}
            className={`btn btn-save ${confirmClassName}`}
            disabled={loading || confirmDisabled}
          >
            {loading ? (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                <div style={{
                  width: '16px',
                  height: '16px',
                  border: '2px solid rgba(255,255,255,0.3)',
                  borderTop: '2px solid white',
                  borderRadius: '50%',
                  animation: 'spin 1s linear infinite'
                }}></div>
                Processing...
              </div>
            ) : (
              confirmText
            )}
          </button>
          {cancelText && (
            <button onClick={onCancel} className="btn btn-secondary" disabled={loading}>{cancelText}</button>
          )}
        </div>
      </div>
    </div>
  );
}

export default ConfirmationDialog;